export default {
    darkOrangePrimary: "#C7C39D",
    darkOrangeBackground: "#615F4D",
    orangeDark: "#7D3100",
    orangePrimary: "#FF7923",
    orangeSecondary: "#FFBB95",
    orangeTertiary: "#FFE0CF",
    orangeBackground: "#FFF6F0",

    darkPurplePrimary: "#4B55BF",
    darkPurpleBackground: "#444873",
    darkPurpleTagBorder: "#B5ADC6",
    darkPurpleTagBackground: "#4D4A5F",
    purpleDark: "#280074",
    purplePrimary: "#6717FF",
    purpleSecondary: "#AA8DFA",
    purpleTertiary: "#D9CCFD",
    purpleBackground: "#F5F2FE",

    darkGreenPrimary: "#B1C7B4",
    darkGreenBackground: "#4D6150",
    greenDark: "#004628",
    greenPrimary: "#00DE80",
    greenSecondary: "#81EFC0",
    greenTertiary: "#BFF7DF",
    greenBackground: "#E4FBF1",

    darkPinkPrimary: "#885794",
    darkPinkBackground: "#5D4D61",
    pinkDark: "#8F1459",
    pinkPrimary: "#FF69BD",
    pinkSecondary: "#FFB4DE",
    pinkTertiary: "#FFD8EE",
    pinkBackground: "#FEF0F8",

    darkBluePrimary: "#4B81BF",
    darkBlueBackground: "#354F6D",
    blueDark: "#034F6D",
    bluePrimary: "#1EBEFF",
    blueSecondary: "#78D8FF",
    blueTertiary: "#BCECFF",
    blueBackground: "#E9F9FF",

    white: "#FFFFFF",
    black: "#000000",
    lightBlack: "#262626",
    grey_1: "#58696C",
    grey_2: "#B3CBCB",
    grey_3: "#D2E5E4",
    grey_4: "#EDF5F4",
    grey_5: "#F6FAF9",
    grey_6: "#F5F5F5",
    greyTableHeader: "#E3E5E4",
    notGreenGrey: "#FAF8FA",

    orange: "#FFC40E",
    uiOrange: "#F1CE68",

    darkWarningPrimary: "#A66262",
    darkWarningBackground: "#614D4D",
    warningDark: "#B20909",
    warningDark2: "#7D3E3E",
    warningDark3: "#A66262",
    warningDark4: "#733C3C",
    warningPrimary: "#FF2E2E",
    warningSecondary: "#FF8282",
    warningTertiary: "#FFC0C0",
    warningBackground: "#FFEAEA",

    uiWarningLight: "#BA586D",
    uiWarning: "#AD1C3B",
    uiWarningDark: "#701226",

    uiGreenLight: "#449972",
    uiGreen: "#049372",
    uiGrey: "#FAF8FA",

    tagPrimary: "#FF0096",
    tagHover: "#7C3A8F",

    transparent: "transparent",

    instanceStateRunning: "#F7C446",

    dark: "#3F4247",
    dark2: "#2F3136",
    dark3: "#202225",
    dark4: "#454B4C",
    dark5: "#495557",

    yellow1: "#7D5A00",
    yellow2: "#FFD338",
    yellow3: "#FFF9E4",

    darkYellow3: "#FFD182",

    syntaxColors: {
        dark: {
            env: "#A06EFF",
            process: "#B38BFF",
            trigger: "#C6A8FF",
            result: "#D9C5FF",
            variable: "#E4D6FF",
            source: "#78D8FF",
            index: "#40E6A0",
            this: "#80EFBF",
            each: "#FFDDC8",
            if: "#FFBC91",
            bracket: "#ffd700",
        },
        light: {
            env: "#340C80",
            process: "#400E9F",
            trigger: "#4D11BF",
            result: "#5A14DF",
            variable: "#6717FF",
            source: "#034F6D",
            index: "#00A660",
            this: "#006F40",
            each: "#9F4C16",
            if: "#803D12",
            bracket: "#af00db",
        },
    },
};
